import React from 'react';
import { Button, Popconfirm, Popover, Tooltip, message, notification } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	acceptWorkOrderForSupplier,
	declineWorkOrderForSupplier,
	declineWorkOrderForPrivateSupplier,
	workOrdersRestCrudThunksForSupplier,
	reopenWorkOrderForSupplier,
	acceptContractorWorkOrder,
	declineContractorWorkOrder,
	cancelSelfClientWorkOrder,
	approveSelfClientWorkOrder,
	reopenContractorWorkOrder,
} from '../../thunks/work_orders_thunks';
import { getWorkOrderBasePriorityBackgroundColor } from '../../utils/DataFormatterUtils';
import WorkOrderStatusDisplay from '../work_order_status_display/WorkOrderStatusDisplay';
import {
	compareStrings,
	getEntityById,
	isSubContractor,
	isSupplierPayingCustomer,
	isSupplierPayingCustomerAndAdmin,
	nullSafeGet,
	nullSafeGetOrElse,
	uuidv4,
} from '../../utils/DataAccessUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import TransferWorkOrder from '../transfer_work_order/TransferWorkOrder';
import moment from 'moment';
import SupplierChangeStatusWithNoteWorkForm from '../supplier_change_status_with_note_work_form/SupplierChangeStatusWithNoteWorkForm';
import DeclineWorkOrderForm from '../decline_workorder_form/DeclineWorkOrderForm';
import { WORK_ORDER_STATUSES } from '../../constants/WorkOrderStatuses';
import { Link } from 'react-router-dom';
import CancelWorkOrder from '../cancel_work_order/CancelWorkOrder';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { isInternalTech, isUserAllowedToAccess, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { updatePaginationWorkOrders } from '../../thunks/work_orders_thunks_wrapper';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import SubContractWorkOrderModalForm from '../subcontract_work_order_modal_form/SubContractWorkOrderModalForm';
import DeferWorkOrder from '../defer_work_order/DeferWorkOrder';
import {
	biddingOnWorkOrderAssociatedWithAnotherSupplier,
	DEFAULT_NOTIFICATION_DURATION,
	getAllWOIdsToListenForWorkOrder,
	getContractorOrWorkOrderIdBasedOnView,
	getContractorWO,
	getSanitisedWorkOrder,
	getWorkOrderArchivalKey,
	hasUnreadNotesForView,
	isSelfClientWorkOrder,
	isSubContractedFromWorkOrder,
	isSubContractedWorkOrder,
	getPayloadForPartialUpdateOnNewNote,
} from '../../utils/WorkOrderUtils';
import PrivateWorkOrderLock from '../private_work_order_lock/PrivateWorkOrderLock';
import {
	EditOutlined,
	// LockOutlined,
	UsergroupDeleteOutlined,
	UserOutlined,
} from '@ant-design/icons';
import InternalWorkspaceDrawer from '../internal_workspace_drawer/InternalWorkspaceDrawer';
import {
	closeInternalWorkspace,
	openInternalWorkspace,
} from '../../actions/internal_workspace_actions';
import { changeClientView, resetClientView } from '../../actions/client_view_actions';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import OWResult from '../OWResult';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { WebSocketContext } from '../../context/WebSocketContext';
import {
	notify,
	WEB_SOCKET_ENTITY_TYPES,
	WEB_SOCKET_MESSAGE_TYPES,
} from '../../utils/WebSocketUtils';
import NewMessageNotification from '../work_orders_detail_page/NewMessageNotification';
import WorkOrderDetailListener from '../work_orders_detail_page/WorkOrderDetailListener';
import InternalNoteDetailListener from '../work_orders_detail_page/InternalNoteDetailListener';
import { fetchAllInternalNotesForSupplier } from '../../thunks/messages_thunks';
import LockIcon from '../icons/LockIcon';
import DrawerOpenIcon from '../icons/DrawerOpenIcon';

const isEqual = require('fast-deep-equal');

const queryString = require('qs');
require('./SupplierWorkOrdersDetailPage.less');

class SupplierWorkOrdersDetailPage extends React.Component<any, any> {
	static contextType = WebSocketContext;

	state = {
		loading: true,
		backLinkTo: '/supplier/workOrders',
		backLinkText: 'Back to work orders',
		reopenModalVisible: false,
		cancelModalVisible: false,
		subContractWorkOrderFormVisible: false,
		declineWorkOrderFormVisible: false,
		isPrivateSupplier: false,
		tab: 'active',
		allowedToDenyWork: false,
		allowedToTransferWork: true,
		fromTargetCollectionName: null,
		deferModalVisible: false,
		actionLoading: null,
	};

	formRefs: any = {
		transferWorkOrderForm: null,
	};

	handleMessage = (event) => {
		const { location, workOrder, updateWorkOrderPartiallyInRedux, history, isClientView } =
			this.props;

		try {
			const data = JSON.parse(event.data);

			if (data.entityType === WEB_SOCKET_ENTITY_TYPES.WORK_ORDER_INTERNAL_NOTES) return;

			const isNotesUrl = location.pathname.includes('notes');

			if (isNotesUrl) return;

			const workOrderId = getContractorOrWorkOrderIdBasedOnView(workOrder, isClientView);
			if (data.workOrderId != workOrderId) return;

			switch (data.messageType) {
				case WEB_SOCKET_MESSAGE_TYPES.NEW_NOTE:
					const partialUpdate = getPayloadForPartialUpdateOnNewNote(workOrder, isClientView);
					updateWorkOrderPartiallyInRedux(partialUpdate);
					const notificationKey = uuidv4();
					notify();
					notification.open({
						key: notificationKey,
						message: <NewMessageNotification data={data} />,
						placement: 'topRight',
						duration: DEFAULT_NOTIFICATION_DURATION,
						onClick: () => {
							notification.close(notificationKey);
							history.replace(
								`/supplier/workOrders/detail/${nullSafeGet('id', workOrder)}/${
									isClientView ? 'notes' : 'contractor_notes'
								}`
							);
						},
					});
					break;
				default:
					break;
			}
		} catch (err) {
			console.log('JSON parse error', err);
		}
	};

	handleInternalNoteMessage = (event) => {
		const { workOrder, isClientView, openInternalWorkspace, fetchInternalNotes } = this.props;

		try {
			const data = JSON.parse(event.data);

			if (data.entityType !== WEB_SOCKET_ENTITY_TYPES.WORK_ORDER_INTERNAL_NOTES) return;

			const workOrderId = getContractorOrWorkOrderIdBasedOnView(workOrder, isClientView);
			if (data.workOrderId != workOrderId) return;

			switch (data.messageType) {
				case WEB_SOCKET_MESSAGE_TYPES.NEW_NOTE:
					notify();
					fetchInternalNotes(workOrderId);
					const notificationKey = uuidv4();
					notification.open({
						key: notificationKey,
						message: <NewMessageNotification data={data} isInternalNote />,
						placement: 'topRight',
						duration: DEFAULT_NOTIFICATION_DURATION,
						onClick: () => {
							notification.close(notificationKey);
							openInternalWorkspace('notes');
						},
					});
					break;
				default:
					break;
			}
		} catch (err) {
			console.log('JSON parse error', err);
		}
	};

	constructor(props) {
		super(props);
		this.handleReopenSubmit = this.handleReopenSubmit.bind(this);
		this.handleReopenCancel = this.handleReopenCancel.bind(this);
		this.showReopenModal = this.showReopenModal.bind(this);
	}

	initializeWorkOrder(ingnoreWOFetch = false) {
		const { getWorkOrder, location, match, currentUser, workOrder } = this.props;
		const workOrderId = match.params.id;

		const isPrivateSupplier = nullSafeGet('facility.status', currentUser) === 'private';
		const internalTechConfig =
			currentUser && currentUser.facility && currentUser.facility.internalTechConfig;

		const { allowedToTransferWork, allowedToDenyWork } = internalTechConfig || {
			allowedToTransferWork: true,
			allowedToDenyWork: false,
		};
		this.setState({
			isPrivateSupplier: isPrivateSupplier,
			allowedToTransferWork,
			allowedToDenyWork,
		});

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({ fromTargetCollectionName: queryParams.targetCollectionName });
		}
		// Only derive the back link from URL params on initial/new-WO navigation
		// (ignoreWOFetch=false). When called due to a workOrder data refresh
		// (ignoreWOFetch=true), the user hasn't navigated — they may be on a sub-tab
		// URL (/notes, /internalSpace, etc.) whose backlinkParams point back to /details,
		// not to the work orders list. Re-parsing those would silently corrupt backLinkTo.
		if (!ingnoreWOFetch) {
			if (queryParams.backlinkParams) {
				const { tab, pathName, backLinkText, ...otherParams } = queryString.parse(
					queryParams.backlinkParams
				);
				const finalPath = pathName || `/supplier/workOrders/overview/${tab ? tab : 'active'}`;
				this.setState({
					tab: tab ? tab : 'active',
					loading: false,
					...(backLinkText && { backLinkText }),
					backLinkTo: `${finalPath}?${new URLSearchParams(otherParams).toString()}`,
				});
			} else {
				this.setState({
					loading: false,
					backLinkTo: `/supplier/workOrders/overview/active`,
				});
			}
		}

		const { updateClientView } = this.props;

		isSelfClientWorkOrder(workOrder, currentUser) && updateClientView(false);

		if (!ingnoreWOFetch) {
			getWorkOrder(workOrderId)
				.then((wo) => {
					isSelfClientWorkOrder(wo, currentUser) && updateClientView(false);
				})
				.catch((error) => {
					this.setState({ error });
				});
		}
	}

	maybeOpenInternalWorkspaceFromUrl() {
		const { location, openInternalWorkspace } = this.props;
		if (!location.pathname.endsWith('/internalSpace')) return;
		const search = location.search.startsWith('?') ? location.search.slice(1) : location.search;
		const params = queryString.parse(search);
		const tab = params.tab === 'attachments' ? 'attachments' : 'notes';
		openInternalWorkspace(tab);
	}

	componentDidMount() {
		// If the URL path ends with contractor_notes, switch to subcontractor view
		const currentPath = this.props.location.pathname;
		if (currentPath.endsWith('/contractor_notes')) {
			this.props.updateClientView(false);
		}
		this.initializeWorkOrder();
		this.maybeOpenInternalWorkspaceFromUrl();
	}

	componentDidUpdate(prevProps, prevState) {
		const { match, workOrder, updateClientView, location } = this.props;
		const { workOrder: prevWorkOrder, match: prevMatch, location: prevLocation } = prevProps;
		if (match.params.id !== prevMatch.params.id) {
			// default the client view to true.
			updateClientView(true);
			this.initializeWorkOrder();
		}

		if (!isEqual(workOrder, prevWorkOrder)) {
			this.initializeWorkOrder(true);
		}

		if (location.pathname !== prevLocation.pathname || location.search !== prevLocation.search) {
			this.maybeOpenInternalWorkspaceFromUrl();
		}
	}

	componentWillUnmount() {
		this.props.resetClientView();
		this.props.closeInternalWorkspace();

		const { refreshWOFromSearch, match } = this.props;
		const workOrderId = match.params.id;
		refreshWOFromSearch(workOrderId);
	}

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const workOrderId = match.params.id;
		const { location } = this.props;
		const queryParams = new URLSearchParams(location.search);
		history.push({
			pathname: `/supplier/workOrders/detail/${workOrderId}/${key}`,
			search: queryParams.toString(),
		});
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(`/${key}`) !== -1;
	};

	handleEdit = () => {
		const { history, workOrder, location } = this.props;
		const editPath = `/supplier/workOrders/edit/${workOrder.id}`;
		history.push(getLinkWIthBackLinkParams(location, 'Back to Work order', editPath));
	};

	handleArchive = () => {
		const { getWorkOrder, archiveWorkOrder, workOrder } = this.props;
		archiveWorkOrder(workOrder).then(() => {
			getWorkOrder(workOrder.id);
		});
	};

	handleUnarchive = () => {
		const { getWorkOrder, unarchiveWorkOrder, workOrder } = this.props;
		unarchiveWorkOrder(workOrder).then(() => {
			getWorkOrder(workOrder.id);
		});
	};

	handleAccept = () => {
		const { acceptWorkOrder, workOrder } = this.props;
		acceptWorkOrder(workOrder);
	};

	handleContractorWOAccept = () => {
		const { acceptContractorWorkOrder, workOrder } = this.props;
		this.setState({ actionLoading: 'accept' });
		acceptContractorWorkOrder(workOrder)
			.then(() => message.success('Work Order accepted!'))
			.catch(message.error)
			.finally(() => this.setState({ actionLoading: null }));
	};

	handleContractorWODecline = () => {
		const { declineContractorWorkOrder, workOrder, history } = this.props;
		this.setState({ actionLoading: 'decline' });
		declineContractorWorkOrder(workOrder)
			.then(() => {
				message.success('Workorder decline!');
				history.goBack();
			})
			.catch(message.error)
			.finally(() => this.setState({ actionLoading: null }));
	};
	handleSubContract = () => {
		this.setState({
			subContractWorkOrderFormVisible: true,
		});
	};

	handleSubContractWorkOrderCancel = (e) => {
		this.setState({
			subContractWorkOrderFormVisible: false,
		});
	};

	handleSubContractSuccess = (switchToClientView) => {
		const { getWorkOrder, workOrder, updateClientView } = this.props;
		this.setState({ subContractWorkOrderFormVisible: false });
		getWorkOrder(workOrder.id);
		if (switchToClientView) {
			updateClientView(true);
		} else {
			message.success(`Work order updated`);
		}
	};

	handleDecline = () => {
		this.setState({
			declineWorkOrderFormVisible: true,
		});
	};

	handleDeclineWorkOrderCancel = (e) => {
		this.setState({
			declineWorkOrderFormVisible: false,
		});
	};

	handleDeclineWorkOrderSubmit = (values: any) => {
		const { history, declineWorkOrder, currentUser, declineWorkOrderPrivate, workOrder } =
			this.props;
		const isPrivateSupplier = nullSafeGet('facility.status', currentUser) === 'private';
		const declineRoute = isPrivateSupplier ? declineWorkOrderPrivate : declineWorkOrder;
		const { backLinkTo } = this.state;
		const workOrderNoteDetails = {
			id: workOrder.id,
			...(values.note && {
				note: {
					text: values.note,
					noteAddedBy: currentUser.email,
					noteAddedAt: moment.utc(),
				},
			}),
		};
		declineRoute(workOrderNoteDetails).then(() => {
			this.setState({ declineWorkOrderFormVisible: false });
			message.success(`Work order declined`);
			history.push(backLinkTo);
		});
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	getLocationText = () => {
		const { isPrivateSupplier } = this.state;
		const { workOrder, isClientView } = this.props;

		const sanitizedWO = getSanitisedWorkOrder(workOrder, isClientView);

		const contractorTenant =
			nullSafeGet('subContractedFromWorkOrder.contractorTenant', workOrder) ||
			nullSafeGet('subContractedToWorkOrder.contractorTenant', workOrder);

		const clientName = nullSafeGetOrElse(
			'name',
			contractorTenant,
			nullSafeGet('location.buyerCompany.name', sanitizedWO)
		);

		return `${!isPrivateSupplier && clientName ? `${clientName} - ` : ''} ${nullSafeGet(
			'location.name',
			sanitizedWO
		)} `;
	};

	handleReopenSubmit() {
		const { reopenWorkOrder, currentUser, workOrder } = this.props;

		const form = this.formRefs['reopenForm'].props.form;

		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const note = {
				text: values.note,
				noteAddedBy: currentUser.email,
				noteAddedAt: moment.utc(),
			};

			const workOrderNoteDetails = {
				id: values.workOrderId,
				locationId: workOrder.locationId,
				note,
			};

			reopenWorkOrder(workOrderNoteDetails).then(() => {
				this.setState({ reopenModalVisible: false });
				message.success(`re-opened for work.`);
			});
		});
	}

	handleReopenCancel(e) {
		this.setState({
			reopenModalVisible: false,
		});
	}

	showReopenModal(e) {
		this.setState({
			reopenModalVisible: true,
		});
	}

	onEditSubContractor = () => {
		this.setState({ subContractWorkOrderFormVisible: true });
	};

	handleSelfClientCancel = () => {
		const { cancelSelfClientWO, workOrder, history } = this.props;
		cancelSelfClientWO(workOrder).then(() =>
			history.push(`/supplier/workOrders/detail/${workOrder.id}`)
		);
	};

	handleApprove = () => {
		const { approveSelfClientWO, workOrder, history } = this.props;
		approveSelfClientWO(workOrder).then(() =>
			history.push(`/supplier/workOrders/detail/${workOrder.id}`)
		);
	};

	handleReopenContractorWO = () => {
		const { reopenContractorWO, workOrder } = this.props;
		this.setState({ actionLoading: 're-open' });
		reopenContractorWO(workOrder)
			.then(() => message.success('Work Order reopened!'))
			.catch(message.error)
			.finally(() => this.setState({ actionLoading: null }));
	};

	openInternalWorkspaceForWorkOrder = () => {
		const { workOrder, openInternalWorkspace, history, location } = this.props;
		openInternalWorkspace('notes');
		const id = nullSafeGet('id', workOrder);
		if (id) {
			// Preserve `location.search` instead of wrapping it via
			// getLinkWIthBackLinkParams. Wrapping would point the next backlinkParams
			// at this WO's own `/details` page, and on drawer close DetailPageHeader
			// would re-derive the navbar's "Back to Work Orders" target from those
			// wrapped params and break the back button. Mirror the symmetric
			// behavior in InternalWorkspaceDrawer.onClose, which also preserves search.
			history.push({
				pathname: `/supplier/workOrders/detail/${id}/internalSpace`,
				search: location.search,
			});
		}
	};

	contactSupportForUpgrade = () => {
		// @ts-ignore
		if (window.Intercom) {
			// @ts-ignore
			window.Intercom('startConversation', 'Interested in Supplier pro');
		}
	};

	renderTabsRightActions = () => {
		const hasInternalWorkspaceAccess =
			isSupplierPayingCustomer(this.props.currentUser) || isInternalTech(this.props.currentUser);
		const internalWorkspaceButton = (
			<Button
				ghost={true}
				onClick={hasInternalWorkspaceAccess ? this.openInternalWorkspaceForWorkOrder : undefined}
				className="!bodyregular relative bottom-2.5 h-[32.4px] rounded-[2px] !border-[1.5px] !border-grey-5 !bg-teal-1 px-[15px] py-1 !text-character-primary"
			>
				<span className="!inline-flex items-center gap-2">
					{!hasInternalWorkspaceAccess ? (
						<span className="footnoteregular inline-flex items-center gap-[3px] rounded-[100px] bg-teal-2 px-1.5 py-[1px] capitalize text-white">
							<LockIcon />
							<span>Pro</span>
						</span>
					) : null}
					<span>INTERNAL WORKSPACE</span>
					{hasInternalWorkspaceAccess && <DrawerOpenIcon className="text-character-primary" />}
				</span>
			</Button>
		);
		return (
			<div className="flex items-center gap-2">
				{hasInternalWorkspaceAccess ? (
					internalWorkspaceButton
				) : (
					<Tooltip
						placement="top"
						mouseLeaveDelay={0.3}
						title={
							<div className="flex flex-col gap-3 py-1">
								<span>Pro users can share notes and attachments to their internal team</span>
								<button
									type="button"
									onClick={this.contactSupportForUpgrade}
									className="bodyregularunderline inline-flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-left text-white"
								>
									Contact Support to Upgrade →
								</button>
							</div>
						}
					>
						{internalWorkspaceButton}
					</Tooltip>
				)}
			</div>
		);
	};

	render() {
		const {
			workOrder,
			match,
			currentUser,
			location,
			history,
			work_orders,
			cloneTargetCollection,
			updatePagination,
			isClientView,
			companyConfig,
		} = this.props;
		const { loading, error } = this.state;
		const workOrderId = match.params.id;
		// For subcontracted work orders, use view-specific unread checks
		// Client notes and contractor notes have separate unread indicators
		const hasUnreadNotesBasedOnView = hasUnreadNotesForView(workOrder, isClientView);
		const isLinkedOrderTabVisible =
			isInternalTech(currentUser) &&
			isUserAllowedToAccess(ROLE_TYPES.SUPPLIER)(
				PERMISSION_NAMES.VIEW_LINKED_WORK_ORDERS,
				companyConfig,
				nullSafeGet('roles', currentUser)
			);

		const notesTabName =
			(isSupplierPayingCustomer(currentUser) || isInternalTech(currentUser)) && isClientView
				? 'Client Notes'
				: 'Notes';

		const selfClientWorkOrder = isSelfClientWorkOrder(workOrder, currentUser);

		if (error) {
			return <OWResult error={error} />;
		}

		const canViewQuotes = isUserAllowedToAccess(ROLE_TYPES.SUPPLIER)(
			PERMISSION_NAMES.CAN_VIEW_QUOTES,
			companyConfig,
			currentUser.roles
		);
		const canViewInvoices = isUserAllowedToAccess(ROLE_TYPES.SUPPLIER)(
			PERMISSION_NAMES.CAN_VIEW_INVOICES,
			companyConfig,
			currentUser.roles
		);

		const tabs = this.state.isPrivateSupplier
			? [
					{
						key: 'details',
						name: 'Overview',
					},
					{
						key: 'charges',
						name: 'Parts & Equipment',
					},
					...(canViewInvoices
						? [
								{
									key: 'invoices',
									name: 'Invoices',
								},
						  ]
						: []),
					...(canViewQuotes
						? [
								{
									key: 'quotes',
									name: 'Quotes',
								},
						  ]
						: []),
					{
						key: 'notes',
						name: hasUnreadNotesBasedOnView ? (
							<>
								{notesTabName} <span className="Notification_badge ml-1 align-middle" />
							</>
						) : (
							notesTabName
						),
					},
					...(isLinkedOrderTabVisible
						? [
								{
									key: 'linked',
									name: `Linked Work Orders ${
										nullSafeGet('linkedToWorkOrders.length', workOrder)
											? `(${nullSafeGet('linkedToWorkOrders.length', workOrder)})`
											: ''
									}`,
								},
						  ]
						: []),
			  ]
			: this.props.isClientView
			? [
					{
						key: 'details',
						name: `${getContractorWO(workOrder, false) ? 'Client - ' : ''}Overview`,
					},
					...(isSubContractor(currentUser, workOrder)
						? [
								...(canViewQuotes
									? [
											{
												key: 'quotes',
												name: 'Proposals',
											},
									  ]
									: []),
								...(canViewInvoices
									? [
											{
												key: 'invoices',
												name: 'Invoices',
											},
									  ]
									: []),
								{
									key: 'contractor_notes',
									name: hasUnreadNotesBasedOnView ? (
										<>
											Notes <span className="Notification_badge ml-1 align-middle" />
										</>
									) : (
										`Notes`
									),
								},
						  ]
						: [
								...(canViewQuotes
									? [
											{
												key: 'quotes',
												name: 'Proposals',
											},
									  ]
									: []),
								...(canViewInvoices
									? [
											{
												key: 'invoices',
												name: 'Invoices',
											},
									  ]
									: []),
								{
									key: 'charges',
									name: 'Parts & Equipment',
								},
								{
									key: 'notes',
									name: hasUnreadNotesBasedOnView ? (
										<>
											{notesTabName} <span className="Notification_badge ml-1 align-middle" />
										</>
									) : (
										notesTabName
									),
								},
						  ]),
					...(isLinkedOrderTabVisible
						? [
								{
									key: 'linked',
									name: `Linked Work Orders ${
										nullSafeGet('linkedToWorkOrders.length', workOrder)
											? `(${nullSafeGet('linkedToWorkOrders.length', workOrder)})`
											: ''
									}`,
								},
						  ]
						: []),
			  ]
			: [
					{
						key: 'details',
						name: 'Subcontractor - Overview',
					},
					{
						key: 'quotes',
						name: 'Proposals',
					},
					{
						key: 'invoices',
						name: 'Invoices',
					},
					{
						key: 'contractor_notes',
						name: hasUnreadNotesBasedOnView ? (
							<>
								Notes <span className="Notification_badge ml-1 align-middle" />
							</>
						) : (
							`Notes`
						),
					},
			  ];

		const differentAssignedSupplier =
			nullSafeGet('facility.id', currentUser) !== workOrder.supplierFacilityId;

		const bidderReadWO = biddingOnWorkOrderAssociatedWithAnotherSupplier(workOrder, currentUser);

		const isAssignedToInternalTech =
			nullSafeGetOrElse('supplierFacility.status', workOrder, '') === 'private';

		const requestQuotesAction =
			workOrder.displayStatus !== 'Completed' &&
			workOrder.displayStatus !== 'Cancelled' &&
			(isAssignedToInternalTech ||
				compareStrings(workOrder.status, WORK_ORDER_STATUSES.unassigned)) ? (
				nullSafeGetOrElse('rfpDataIds.length', workOrder, 0) === 0 ? (
					<Link
						to={`/supplier/requestsForProposal/overview/new?workOrderId=${workOrderId}`}
						style={{ marginLeft: 16, marginBottom: 16 }}
					>
						<Button ghost={true}>Request Quotes</Button>
					</Link>
				) : (
					<Link
						to={`/supplier/requestsForProposal/detail/${workOrder.rfpDataIds[0]}/details`}
						style={{ marginLeft: 16, marginBottom: 16 }}
					>
						<Button ghost={true}>View RFP</Button>
					</Link>
				)
			) : (
				[]
			);

		const privateTransferAction =
			this.state.isPrivateSupplier && this.state.allowedToTransferWork
				? [
						<div style={{ marginLeft: 16, marginBottom: 16 }}>
							<TransferWorkOrder workOrder={workOrder} />
						</div>,
				  ]
				: isSupplierPayingCustomerAndAdmin(currentUser) && !isSubContractedWorkOrder(workOrder)
				? [
						<Button
							key={3}
							ghost={true}
							style={{ marginLeft: 16, marginBottom: 16 }}
							onClick={this.handleSubContract}
						>
							Subcontract
						</Button>,
				  ]
				: [];

		const privateDenyAction =
			this.state.isPrivateSupplier && this.state.allowedToDenyWork
				? [
						<Popconfirm
							onConfirm={this.handleDecline}
							placement="topLeft"
							title="Are you sure you want to decline?"
							okText="Yes"
							cancelText="No"
						>
							<Button key={2} ghost={true} style={{ marginLeft: 16, marginBottom: 16 }}>
								Decline
							</Button>
						</Popconfirm>,
				  ]
				: [];

		const privateEditAction = this.state.isPrivateSupplier
			? [
					<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_WORK_ORDERS}>
						<Button
							key={4}
							ghost={true}
							style={{ marginLeft: 16, marginBottom: 16 }}
							onClick={this.handleEdit}
						>
							Edit
						</Button>
					</AccessPermissionChecker>,
			  ]
			: !differentAssignedSupplier &&
			  nullSafeGet('isSupplierInitiated', workOrder) &&
			  isSupplierPayingCustomerAndAdmin(currentUser) &&
			  getSanitisedWorkOrder(workOrder, isClientView).displayStatus !==
					WORK_ORDER_DISPLAY_STATUSES.cancelled &&
			  isClientView
			? [
					<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_WORK_ORDERS}>
						<Button
							key={4}
							ghost={true}
							style={{ marginLeft: 16, marginBottom: 16 }}
							onClick={this.handleEdit}
						>
							Edit
						</Button>
					</AccessPermissionChecker>,
			  ]
			: [];

		const privateCancelAction =
			this.state.isPrivateSupplier ||
			(nullSafeGet('isSupplierInitiated', workOrder) &&
				!isSubContractedFromWorkOrder(workOrder) &&
				isClientView)
				? [
						<AccessPermissionChecker name={PERMISSION_NAMES.CANCEL_WORK_ORDERS}>
							<CancelWorkOrder
								cancelButton={
									<Button key={5} ghost={true} style={{ marginLeft: 16, marginBottom: 16 }}>
										Cancel
									</Button>
								}
								workOrder={workOrder}
							/>
						</AccessPermissionChecker>,
				  ]
				: [];

		const privateReopenAction =
			this.state.isPrivateSupplier || isSupplierPayingCustomerAndAdmin(currentUser)
				? [
						<AccessPermissionChecker name={PERMISSION_NAMES.REOPEN_WORK_ORDERS}>
							<Button
								key={6}
								ghost={true}
								style={{ marginLeft: 16, marginBottom: 16 }}
								onClick={this.showReopenModal}
								loading={this.state.actionLoading === 're-open'}
							>
								Re-open
							</Button>
						</AccessPermissionChecker>,
				  ]
				: [];
		const deferWorkOrder = this.state.isPrivateSupplier ? (
			<DeferWorkOrder
				workOrder={workOrder}
				buttonProps={{
					style: { marginBottom: 16, marginLeft: 16 },
					ghost: true,
				}}
				buttonText={'Defer'}
			/>
		) : null;

		const selfClientActions = selfClientWorkOrder ? (
			<div>
				<Button
					key={6}
					ghost={true}
					style={{ marginLeft: 16, marginBottom: 16 }}
					onClick={this.handleApprove}
				>
					Approve
				</Button>
				,
				<Button
					key={6}
					ghost={true}
					style={{ marginLeft: 16, marginBottom: 16 }}
					onClick={this.handleSelfClientCancel}
				>
					Cancel
				</Button>
			</div>
		) : null;

		const sanitisedWO = getSanitisedWorkOrder(workOrder, isClientView);

		const priorityColor = getWorkOrderBasePriorityBackgroundColor(sanitisedWO.woPriority);

		const workOrderActions = bidderReadWO ? null : sanitisedWO[
				getWorkOrderArchivalKey(currentUser)
		  ] ? (
			<Button
				ghost={true}
				style={{ marginBottom: 16, marginLeft: 16 }}
				onClick={this.handleUnarchive}
			>
				Unarchive
			</Button>
		) : sanitisedWO.displayStatus === WORK_ORDER_DISPLAY_STATUSES.open ? (
			this.state.isPrivateSupplier ? (
				privateTransferAction
					.concat(requestQuotesAction)
					.concat(privateDenyAction)
					.concat(privateEditAction)
					.concat(privateCancelAction)
					.concat(deferWorkOrder)
			) : this.props.isClientView ? (
				[
					<Button
						key={1}
						ghost={true}
						style={{ marginBottom: 16, marginLeft: 16 }}
						loading={this.state.actionLoading === 'accept'}
						onClick={
							isSubContractedFromWorkOrder(workOrder) || selfClientWorkOrder
								? this.handleContractorWOAccept
								: this.handleAccept
						}
					>
						Accept
					</Button>,
					<Popconfirm
						onConfirm={
							isSubContractedFromWorkOrder(workOrder)
								? this.handleContractorWODecline
								: this.handleDecline
						}
						placement="topLeft"
						title="Are you sure you want to decline?"
						okText="Yes"
						cancelText="No"
					>
						<Button
							key={2}
							loading={this.state.actionLoading === 'decline'}
							ghost={true}
							style={{ marginBottom: 16, marginLeft: 16 }}
						>
							Decline
						</Button>
					</Popconfirm>,
				].concat(privateCancelAction)
			) : (
				[]
			)
		) : sanitisedWO.displayStatus === 'Pending' ? (
			[
				<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_WORK_ORDERS}>
					<Button
						key={1}
						ghost={true}
						style={{ marginBottom: 16, marginLeft: 16 }}
						onClick={this.handleEdit}
					>
						Edit
					</Button>
				</AccessPermissionChecker>,
			]
				.concat(requestQuotesAction)
				.concat(privateTransferAction)
				.concat(privateDenyAction)
				.concat(privateCancelAction)
				.concat(deferWorkOrder)
		) : workOrder.displayStatus === 'Completed' || workOrder.displayStatus === 'Cancelled' ? (
			[
				<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_WORK_ORDERS}>
					<Link
						to={getLinkWIthBackLinkParams(
							location,
							'Back to Work order',
							`/supplier/workOrders/editSafe/${workOrderId}`
						)}
						style={{ marginBottom: 16, marginLeft: 16 }}
					>
						<Button ghost={true}>Edit</Button>
					</Link>
				</AccessPermissionChecker>,
				<Button
					ghost={true}
					style={{ marginBottom: 16, marginLeft: 16 }}
					onClick={this.handleArchive}
				>
					Archive
				</Button>,
			].concat(privateReopenAction)
		) : (
			[]
				.concat(requestQuotesAction)
				.concat(privateTransferAction)
				.concat(privateDenyAction)
				.concat(privateEditAction)
				.concat(privateCancelAction)
		);

		const contractorWOReopenAction =
			compareStrings(sanitisedWO.displayStatus, WORK_ORDER_DISPLAY_STATUSES.complete) ||
			compareStrings(sanitisedWO.displayStatus, WORK_ORDER_DISPLAY_STATUSES.cancelled)
				? [
						<AccessPermissionChecker name={PERMISSION_NAMES.REOPEN_WORK_ORDERS}>
							<Button
								key={6}
								ghost={true}
								style={{ marginLeft: 16, marginBottom: 16 }}
								onClick={this.handleReopenContractorWO}
								loading={this.state.actionLoading === 're-open'}
							>
								Re-open
							</Button>
						</AccessPermissionChecker>,
				  ]
				: [];

		const contractorWOPendingActions = compareStrings(
			sanitisedWO.displayStatus,
			WORK_ORDER_DISPLAY_STATUSES.complete
		)
			? selfClientActions
			: [];

		const contractorViewActions = contractorWOReopenAction.concat(contractorWOPendingActions);
		const entityIds = getAllWOIdsToListenForWorkOrder(nullSafeGet('workOrder', this.props));
		return (
			<div className="supplierWorkOrdersDetailPage">
				<WorkOrderDetailListener
					socketContext={this.context}
					onMessage={this.handleMessage}
					entityIds={entityIds}
				/>
				<InternalNoteDetailListener
					socketContext={this.context}
					onMessage={this.handleInternalNoteMessage}
					entityIds={entityIds}
				/>
				<SupplierChangeStatusWithNoteWorkForm
					wrappedComponentRef={this.saveFormRef('reopenForm')}
					visible={this.state.reopenModalVisible}
					workOrderId={workOrder.id}
					onCancel={this.handleReopenCancel}
					onSubmit={this.handleReopenSubmit}
					formTitle={'Not done yet. Re-open?'}
					formText={'Re-open'}
				/>
				{this.state.subContractWorkOrderFormVisible ? (
					<SubContractWorkOrderModalForm
						formData={workOrder}
						onCancel={this.handleSubContractWorkOrderCancel}
						onSuccess={this.handleSubContractSuccess}
					/>
				) : null}
				<DeclineWorkOrderForm
					formData={workOrder}
					visible={this.state.declineWorkOrderFormVisible}
					onCancel={this.handleDeclineWorkOrderCancel}
					onSubmit={this.handleDeclineWorkOrderSubmit}
				/>
				{isSupplierPayingCustomer(currentUser) || isInternalTech(currentUser) ? (
					<InternalWorkspaceDrawer />
				) : null}
				<DetailPageHeader
					getHTMLTitle={
						nullSafeGet('id', workOrder)
							? () => `WO #${workOrder.id} - ${workOrder.title} - OpenWrench`
							: null
					}
					headerClassName="supplier-workorder-detail-header"
					exactPath={'/supplier/workOrders/detail/:id'}
					redirectPath={`/supplier/workOrders/detail/${workOrderId}/details`}
					backLinkText={this.state.backLinkText}
					backLinkTo={this.state.backLinkTo}
					additionalHeader={
						isSupplierPayingCustomer(currentUser) && isSubContractedWorkOrder(workOrder) ? (
							<div className="subcontractor-switch-header flex w-full items-center justify-between bg-supplier px-10 py-2">
								<span>
									{this.props.isClientView ? (
										<UserOutlined style={{ color: 'white' }} />
									) : (
										<UsergroupDeleteOutlined style={{ color: 'white' }} />
									)}
									<span className="ml-2 text-lg text-white">
										Viewing as a {this.props.isClientView ? 'client' : 'subcontractor'}
									</span>
								</span>
								<Popover
									content={
										selfClientWorkOrder ? 'You cannot switch to client view for this Workorder' : ''
									}
									trigger="hover"
								>
									<Button
										onClick={() => {
											this.props.updateClientView(!this.props.isClientView);
											this.handleTabChange('details');
										}}
										type="text"
										style={{ color: 'white' }}
										disabled={selfClientWorkOrder}
									>
										{`Switch to ${this.props.isClientView ? 'Subcontractor' : 'Client'} View`}
									</Button>
								</Popover>
							</div>
						) : null
					}
					title={
						loading ? null : (
							<>
								<div className="flex justify-between">
									<span>
										{sanitisedWO.title}
										<PrivateWorkOrderLock
											workOrder={workOrder}
											style={{ marginTop: -4, marginRight: 8, marginLeft: 8 }}
											fontSize={24}
										/>
									</span>
								</div>
							</>
						)
					}
					subtitle={
						<div className="flex flex-col flex-wrap">
							<div>
								{nullSafeGet('id', workOrder) && (
									<span className="workOrdersDetailPage__subtitle">
										WO# {nullSafeGet('id', workOrder)}
									</span>
								)}
							</div>
							{bidderReadWO ? null : nullSafeGet(
									'subContractedToWorkOrder.subSupplierFacility.id',
									workOrder
							  ) ? (
								isClientView ? null : (
									<div className="workOrdersDetailPage__subtitle flex flex-row items-center">
										<div>
											Subcontracted to{' '}
											{nullSafeGet(
												'subContractedToWorkOrder.subSupplierFacility.displayName',
												workOrder
											)}
										</div>
										<div className="ml-2 cursor-pointer">
											<EditOutlined onClick={this.onEditSubContractor} />
										</div>
									</div>
								)
							) : null}
							<div className="flex flex-row flex-wrap">
								<WorkOrderStatusDisplay
									className="workOrdersDetailPage__subtitle"
									status={sanitisedWO.status}
									displayStatus={sanitisedWO.displayStatus}
									darkMode={true}
								/>
								<span className="workOrdersDetailPage__subtitle">
									{nullSafeGet('woPriority.name', workOrder)}
								</span>
							</div>
						</div>
					}
					subtext={<div className="body1"> {this.getLocationText()}</div>}
					actions={
						<div className="flex flex-row items-center justify-end">
							{isClientView ? workOrderActions : contractorViewActions}
							<NextPreviousButton
								key={this.state.fromTargetCollectionName}
								location={location}
								history={history}
								activeId={workOrder.id}
								getEnitityUrl={(id) => `/supplier/workOrders/detail/${id}/details`}
								stateSlice={work_orders}
								targetCollectionName={this.state.fromTargetCollectionName}
								updatePagination={updatePagination}
								cloneTargetCollection={cloneTargetCollection}
								entityName="work order"
								wrapperclassName="shrink-0 ml-4 mb-4"
							/>
						</div>
					}
					tabs={bidderReadWO ? [] : tabs}
					backgroundColor={priorityColor}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					childRoutes={this.props.childRoutes}
					tabsRightActions={this.renderTabsRightActions}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	match: ownProps.match,
	location: ownProps.location,
	history: ownProps.history,
	currentUser: state.session.currentUser,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	navbar: state.navbar,
	work_orders: state.work_orders,
	isClientView: state.clientView.isClientView,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	getWorkOrderDelta: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readDelta(id)),
	archiveWorkOrder: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.archive(entity, 'id', true)),
	unarchiveWorkOrder: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.unarchive(entity, 'id', true)),
	acceptWorkOrder: (entity) => dispatch(acceptWorkOrderForSupplier(entity, 'id')),
	declineWorkOrder: (entity) => dispatch(declineWorkOrderForSupplier(entity, 'id')),
	declineWorkOrderPrivate: (entity) => dispatch(declineWorkOrderForPrivateSupplier(entity, 'id')),
	reopenWorkOrder: (entity) => dispatch(reopenWorkOrderForSupplier(entity)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationWorkOrders('supplier')(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
	cloneTargetCollection: (from, to) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updateClientView: (isClientView) => dispatch(changeClientView(isClientView)),
	resetClientView: () => dispatch(resetClientView()),
	openInternalWorkspace: (activeTab) => dispatch(openInternalWorkspace(activeTab)),
	closeInternalWorkspace: () => dispatch(closeInternalWorkspace()),
	acceptContractorWorkOrder: (entity) => dispatch(acceptContractorWorkOrder(entity)),
	declineContractorWorkOrder: (entity) => dispatch(declineContractorWorkOrder(entity)),
	cancelSelfClientWO: (entity) => dispatch(cancelSelfClientWorkOrder(entity)),
	approveSelfClientWO: (entity) => dispatch(approveSelfClientWorkOrder(entity)),
	reopenContractorWO: (entity) => dispatch(reopenContractorWorkOrder(entity)),
	updateWorkOrderPartiallyInRedux: (workOrder) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(workOrder)),
	refreshWOFromSearch: (id) => dispatch(workOrdersRestCrudThunksForSupplier.read({ id })),
	fetchInternalNotes: (workOrderId) => dispatch(fetchAllInternalNotesForSupplier(workOrderId)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrdersDetailPage)
);
